// Components==============
import Layout from 'components/Layout/Layout';
import React from 'react';
import './MyMessages.module.scss';
// =========================

export default function MyMessages() {
  return (
    <Layout grey>
      <></>
    </Layout>
  );
}
